<script>
  import uuid from "uuid-v4"
  import Accordion from "../Accordion.svelte"
  import DeudasGrafico from "./Deudas_grafico_chart.svelte"
  import DeudasDetalle from "./Deudas_detalle.svelte"
  import DeudasUtilizacion from "./Deudas_utilizacion.svelte"
  import DeudasResumenFinanciero from "./Deudas_resumen_financiero.svelte"

  export let documento

  let load = {
    deudas: false,
    detalle: false,
    utilizacion: false,
    resumen_financiero: false,
  }

  const click = (ops) => {
    switch (ops) {
      case "deudas":
        load.deudas = true
        break
      case "detalle":
        load.detalle = true
        break
      case "utilizacion":
        load.utilizacion = true
        break
      case "resumen_financiero":
        load.resumen_financiero = true
      default:
        break
    }
  }
</script>

<div>
  <Accordion title="Gráfico" idx={uuid()} on:click={() => click("deudas")}>
    {#if load.deudas}
      <DeudasGrafico {documento} />
    {/if}
  </Accordion>
  <Accordion title="Detalle" idx={uuid()} on:click={() => click("detalle")}>
    {#if load.detalle}
      <DeudasDetalle {documento} />
    {/if}
  </Accordion>
  <Accordion
    title="Utilización"
    idx={uuid()}
    on:click={() => click("utilizacion")}
  >
    {#if load.utilizacion}
      <DeudasUtilizacion {documento} />
    {/if}
  </Accordion>
  <Accordion
    title="Resumen Financiero"
    idx={uuid()}
    on:click={() => click("resumen_financiero")}
  >
    {#if load.resumen_financiero}
      <DeudasResumenFinanciero {documento} />
    {/if}
  </Accordion>
</div>
